import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Transactions from "./pages/Transactions";
import CashFlow from "./pages/CashFlow";
import Financing from "./pages/Financing";
import Fleet from "./pages/Fleet";
import Envanter from "./pages/Envanter";
import Contracts from "./pages/Contracts";
import VehicleProfitability from "./pages/VehicleProfitability";
import Karsilastirma from "./pages/Karsilastirma";
import ButceAnaliz from "./pages/ButceAnaliz";
import Settings from "./pages/Settings";
import Users from "./pages/Users";

function Protected({ children, adminOnly }) {
  const { user, checking } = useAuth();
  if (checking) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Yükleniyor...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function Shell() {
  const { user, checking } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={checking ? null : user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/gelir" element={<Protected><Transactions type="income" key="income" /></Protected>} />
      <Route path="/gider" element={<Protected><Transactions type="expense" key="expense" /></Protected>} />
      <Route path="/nakit-akis" element={<Protected><CashFlow /></Protected>} />
      <Route path="/finansman" element={<Protected><Financing /></Protected>} />
      <Route path="/filo" element={<Protected><Fleet /></Protected>} />
      <Route path="/envanter" element={<Protected><Envanter /></Protected>} />
      <Route path="/sozlesmeler" element={<Protected><Contracts /></Protected>} />
      <Route path="/arac-karliligi" element={<Protected><VehicleProfitability /></Protected>} />
      <Route path="/karsilastirma" element={<Protected><Karsilastirma /></Protected>} />
      <Route path="/butce-analiz" element={<Protected><ButceAnaliz /></Protected>} />
      <Route path="/kullanicilar" element={<Protected adminOnly><Users /></Protected>} />
      <Route path="/ayarlar" element={<Protected adminOnly><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
